module.exports = __webpack_public_path__ + "static/2invgde-a81401f14c9c6a43672e0175c272ccf9.gif";